import IconBase from "./IconBase";

// A droplet of paint.
const ColorIcon = (props) => (
    <IconBase {...props}>
        <path d="M12 3.25s-6.75 7.2-6.75 11.3a6.75 6.75 0 0 0 13.5 0C18.75 10.45 12 3.25 12 3.25Z" />
    </IconBase>
);

export default ColorIcon;
